import { getModelType, getModelId, updateModel, modelToJSON, updateModelId, setModelMetaKey, getModelMetaKey, getRefId, getModelCollection, ReferenceType, getModelClassRefs, PureModel, initModelRef, isModel, isCollection, isView } from 'datx';
import { assignComputed, META_FIELD, mapItems } from 'datx-utils';
import { action, isObservableArray } from 'mobx';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var cacheStorage = [];
function saveCache(url, response, modelType) {
    if (response && 'data' in response && (!('error' in response) || !response.error) && response.data) {
        // The type might need to be 100% correct - used only to clear the cache
        var type = modelType || getModelType(response.data instanceof Array ? response.data[0] : response.data);
        cacheStorage.push({ response: response, time: new Date(), type: type, url: url });
    }
}
function getCache(url) {
    return cacheStorage.find(function (item) { return item.url === url; });
}
function clearAllCache() {
    cacheStorage.length = 0;
}
function clearCacheByType(type) {
    cacheStorage = cacheStorage.filter(function (item) { return item.type !== type; });
}

var MODEL_LINKS_FIELD = 'jsonapiLinks';
var MODEL_REF_LINKS_FIELD = 'jsonapiRefLinks';
var MODEL_REF_META_FIELD = 'jsonapiRefMeta';
var MODEL_META_FIELD = 'jsonapiMeta';
var MODEL_PERSISTED_FIELD = 'jsonapiPersisted';
var MODEL_PROP_FIELD = 'jsonapiProp';
var MODEL_QUEUE_FIELD = 'jsonapiQueue';
var MODEL_RELATED_FIELD = 'jsonapiRelated';
var URL_REGEX = /^((https?\:)?\/\/)/;

var ParamArrayType;
(function (ParamArrayType) {
    ParamArrayType[ParamArrayType["MULTIPLE_PARAMS"] = 0] = "MULTIPLE_PARAMS";
    ParamArrayType[ParamArrayType["COMMA_SEPARATED"] = 1] = "COMMA_SEPARATED";
    ParamArrayType[ParamArrayType["PARAM_ARRAY"] = 2] = "PARAM_ARRAY";
    ParamArrayType[ParamArrayType["OBJECT_PATH"] = 3] = "OBJECT_PATH";
})(ParamArrayType || (ParamArrayType = {}));

// tslint:disable-next-line:no-typeof-undefined - The alternative breaks on node
var isBrowser = typeof window !== 'undefined';
/**
 * Returns the value if it's not a function. If it's a function
 * it calls it.
 *
 * @export
 * @template T
 * @param {(T|(() => T))} target can be  anything or function
 * @returns {T} value
 */
function getValue(target) {
    if (typeof target === 'function') {
        // @ts-ignore
        return target();
    }
    return target;
}
function error(message) {
    return new Error("[datx exception] " + message);
}

var Response = /** @class */ (function () {
    function Response(response, collection, options, overrideData, views) {
        var _this = this;
        /**
         * API response data (synced with the store)
         *
         * @type {(PureModel|Array<PureModel>)}
         * @memberOf Response
         */
        this.data = null;
        this.views = [];
        /**
         * Cache used for the link requests
         *
         * @private
         * @type {IDictionary<Promise<Response>>}
         * @memberOf Response
         */
        this.__cache = {};
        this.__collection = collection;
        this.__options = options;
        this.__response = response;
        this.status = response.status;
        if (views) {
            this.views = views;
        }
        if (collection) {
            this.data = overrideData ? collection.add(overrideData) : collection.sync(response.data);
        }
        else if (response.data) {
            // The case when a record is not in a store and save/remove are used
            var resp = response.data;
            if (resp.data) {
                if (resp.data instanceof Array) {
                    throw new Error('A save/remove operation should not return an array of results');
                }
                this.data = overrideData || new GenericModel(flattenModel(undefined, resp.data));
            }
        }
        this.views.forEach(function (view) {
            if (_this.data) {
                view.add(_this.data);
            }
        });
        this.meta = (response.data && response.data.meta) || {};
        this.links = (response.data && response.data.links) || {};
        this.jsonapi = (response.data && response.data.jsonapi) || {};
        this.headers = response.headers;
        this.requestHeaders = response.requestHeaders;
        this.error = (response.data && response.data.errors) || response.error;
        if (this.links) {
            Object.keys(this.links).forEach(function (link) {
                assignComputed(_this, link, function () { return _this.__fetchLink(link); });
            });
        }
        Object.freeze(this);
        if (this.error) {
            throw this;
        }
    }
    /**
     * Replace the response record with a different record. Used to replace a record while keeping the same reference
     *
     * @param {PureModel} data New data
     * @returns {Response}
     *
     * @memberOf Response
     */
    Response.prototype.replaceData = function (data) {
        var record = this.data;
        if (record === data) {
            return this;
        }
        var newId = getModelId(record);
        var type = getModelType(record);
        var viewIndexes = this.views.map(function (view) { return view.list.indexOf(record); });
        if (this.__collection) {
            this.__collection.removeOne(type, newId);
            this.__collection.add(data);
        }
        updateModel(data, modelToJSON(record));
        updateModelId(data, newId);
        this.views.forEach(function (view, index) {
            if (viewIndexes[index] !== -1) {
                view.list[viewIndexes[index]] = data;
            }
        });
        return new Response(this.__response, this.__collection, this.__options, data);
    };
    /**
     * Function called when a link is being fetched. The returned value is cached
     *
     * @private
     * @param {any} name Link name
     * @returns Promise that resolves with a Response object
     *
     * @memberOf Response
     */
    Response.prototype.__fetchLink = function (name) {
        if (!this.__cache[name]) {
            var link = (this.links && name in this.links) ? this.links[name] : null;
            if (link) {
                this.__cache[name] = fetchLink(link, this.__collection, this.requestHeaders, this.__options, this.views);
            }
        }
        return this.__cache[name];
    };
    __decorate([
        action
    ], Response.prototype, "replaceData", null);
    return Response;
}());

var config = {
    // Base URL for all API calls
    baseUrl: '/',
    // Enable caching by default in the browser
    cache: isBrowser,
    // Default options that will be passed to the fetch function
    defaultFetchOptions: {
        headers: {
            'content-type': 'application/vnd.api+json',
        },
    },
    encodeQueryString: false,
    // Reference of the fetch method that should be used
    fetchReference: isBrowser && 'fetch' in window && typeof window.fetch === 'function' && window.fetch.bind(window)
        || undefined,
    // Determines how will the request param arrays be stringified
    paramArrayType: ParamArrayType.COMMA_SEPARATED,
    /**
     * Base implementation of the fetch function (can be overridden)
     *
     * @param {string} method API call method
     * @param {string} url API call URL
     * @param {object} [body] API call body
     * @param {IHeaders} [requestHeaders] Headers that will be sent
     * @returns {Promise<IRawResponse>} Resolves with a raw response object
     */
    baseFetch: function (method, url, body, requestHeaders) {
        var _this = this;
        var data;
        var status;
        var headers;
        var request = Promise.resolve();
        var uppercaseMethod = method.toUpperCase();
        var isBodySupported = uppercaseMethod !== 'GET' && uppercaseMethod !== 'HEAD';
        return request
            .then(function () {
            var defaultHeaders = config.defaultFetchOptions.headers || {};
            var reqHeaders = Object.assign({}, defaultHeaders, requestHeaders);
            var options = Object.assign({}, config.defaultFetchOptions, {
                body: isBodySupported && JSON.stringify(body) || undefined,
                headers: reqHeaders,
                method: method,
            });
            if (_this.fetchReference) {
                return _this.fetchReference(url, options);
            }
            throw new Error('Fetch reference needs to be defined before using the network');
        })
            .then(function (response) {
            status = response.status;
            headers = response.headers;
            return response.json();
        })
            .catch(function (error) {
            if (status === 204) {
                return null;
            }
            throw error;
        })
            .then(function (responseData) {
            data = responseData;
            if (status >= 400) {
                throw {
                    message: "Invalid HTTP status: " + status,
                    status: status,
                };
            }
            return { data: data, headers: headers, requestHeaders: requestHeaders, status: status };
        })
            .catch(function (error) {
            return _this.onError({ data: data, error: error, headers: headers, requestHeaders: requestHeaders, status: status });
        });
    },
    onError: function (resp) {
        return resp;
    },
    transformRequest: function (options) {
        return options;
    },
    transformResponse: function (response) {
        return response;
    },
};
/**
 * Base implementation of the stateful fetch function (can be overridden)
 *
 * @param {ICollectionFetchOpts} reqOptions API request options
 * @returns {Promise<Response>} Resolves with a response object
 */
function collectionFetch(reqOptions) {
    var _a = config.transformRequest(reqOptions), url = _a.url, options = _a.options, data = _a.data, _b = _a.method, method = _b === void 0 ? 'GET' : _b, collection = _a.collection, views = _a.views;
    var staticCollection = collection && collection.constructor;
    var collectionCache = staticCollection && staticCollection.cache;
    var isCacheSupported = method.toUpperCase() === 'GET';
    var skipCache = reqOptions.options && reqOptions.options.skipCache;
    if (config.cache && isCacheSupported && collectionCache && !skipCache) {
        var cache = getCache(url);
        if (cache) {
            return Promise.resolve(cache.response);
        }
    }
    return config.baseFetch(method, url, data, options && options.headers)
        .then(function (response) {
        var collectionResponse = Object.assign(response, { collection: collection });
        var resp = new Response(config.transformResponse(collectionResponse), collection, options, undefined, views);
        if (config.cache && isCacheSupported) {
            saveCache(url, resp);
        }
        return resp;
    });
}
function libFetch(options) {
    return collectionFetch(options);
}
/**
 * API call used to get data from the server
 *
 * @export
 * @param {IJsonapiCollection} collection Related collection
 * @param {string} url API call URL
 * @param {IHeaders} [headers] Headers to be sent
 * @param {IRequestOptions} [options] Server options
 * @param {Array<View>} [views] Request view
 * @returns {Promise<Response>} Resolves with a Response object
 */
function read(url, collection, headers, options, views) {
    return collectionFetch({
        collection: collection,
        data: undefined,
        method: 'GET',
        options: __assign({}, options, { headers: headers }),
        url: url,
        views: views,
    });
}
/**
 * API call used to create data on the server
 *
 * @export
 * @param {IJsonapiCollection} collection Related collection
 * @param {string} url API call URL
 * @param {object} [data] Request body
 * @param {IHeaders} [headers] Headers to be sent
 * @param {IRequestOptions} [options] Server options
 * @param {Array<View>} [views] Request view
 * @returns {Promise<Response>} Resolves with a Response object
 */
function create(url, data, collection, headers, options, views) {
    return collectionFetch({
        collection: collection,
        data: data,
        method: 'POST',
        options: __assign({}, options, { headers: headers }),
        url: url,
        views: views,
    });
}
/**
 * API call used to update data on the server
 *
 * @export
 * @param {IJsonapiCollection} collection Related collection
 * @param {string} url API call URL
 * @param {object} [data] Request body
 * @param {IHeaders} [headers] Headers to be sent
 * @param {IRequestOptions} [options] Server options
 * @param {Array<View>} [views] Request view
 * @returns {Promise<Response>} Resolves with a Response object
 */
function update(url, data, collection, headers, options, views) {
    return collectionFetch({
        collection: collection,
        data: data,
        method: 'PATCH',
        options: __assign({}, options, { headers: headers }),
        url: url,
        views: views,
    });
}
/**
 * API call used to remove data from the server
 *
 * @export
 * @param {IJsonapiCollection} collection Related collection
 * @param {string} url API call URL
 * @param {IHeaders} [headers] Headers to be sent
 * @param {IRequestOptions} [options] Server options
 * @param {Array<View>} [views] Request view
 * @returns {Promise<Response>} Resolves with a Response object
 */
function remove(url, collection, headers, options, views) {
    return collectionFetch({
        collection: collection,
        data: undefined,
        method: 'DELETE',
        options: __assign({}, options, { headers: headers }),
        url: url,
        views: views,
    });
}
/**
 * Fetch a link from the server
 *
 * @export
 * @param {JsonApi.ILink} link Link URL or a link object
 * @param {IJsonapiCollection} collection Store that will be used to save the response
 * @param {IDictionary<string>} [requestHeaders] Request headers
 * @param {IRequestOptions} [options] Server options
 * @param {Array<View>} [views] Request view
 * @returns {Promise<LibResponse>} Response promise
 */
function fetchLink(link, collection, requestHeaders, options, views) {
    if (link) {
        var href = typeof link === 'object' ? link.href : link;
        if (href) {
            return read(href, collection, requestHeaders, options, views);
        }
    }
    return Promise.resolve(new Response({ data: undefined }, collection));
}
function handleResponse(record, prop) {
    return action(function (response) {
        if (response.error) {
            throw response.error;
        }
        if (response.status === 204) {
            setModelMetaKey(record, MODEL_PERSISTED_FIELD, true);
            return record;
        }
        else if (response.status === 202) {
            var responseRecord = response.data;
            setModelMetaKey(responseRecord, MODEL_PROP_FIELD, prop);
            setModelMetaKey(responseRecord, MODEL_QUEUE_FIELD, true);
            setModelMetaKey(responseRecord, MODEL_RELATED_FIELD, record);
            return responseRecord;
        }
        else {
            setModelMetaKey(record, MODEL_PERSISTED_FIELD, true);
            return response.replaceData(record).data;
        }
    });
}

function prepareQuery(type, id, data, options, collection, model) {
    var queryModel = model && model.constructor;
    if (!queryModel && collection) {
        var staticCollection = collection.constructor;
        queryModel = staticCollection.types.filter(function (item) { return item.type === type; })[0];
    }
    var path = queryModel
        ? (getValue(queryModel['endpoint']) || queryModel['baseUrl'] || getModelType(queryModel))
        : type;
    var url = id ? path + "/" + id : "" + path;
    return buildUrl(url, data, options);
}
function buildUrl(url, data, options) {
    var headers = (options && options.headers) || {};
    var params = prepareFilters((options && options.filter) || {}).concat(prepareSort(options && options.sort), prepareIncludes(options && options.include), prepareFields((options && options.fields) || {}), prepareRawParams((options && options.params) || []));
    if (config.encodeQueryString) {
        params = params.map(encodeParam);
    }
    var baseUrl = appendParams(prefixUrl(url), params);
    return { data: data, headers: headers, url: baseUrl };
}
function prepareFilters(filters) {
    return parametrize(filters).map(function (item) { return "filter[" + item.key + "]=" + item.value; });
}
function prepareSort(sort) {
    return sort ? ["sort=" + sort] : [];
}
function prepareIncludes(include) {
    return include ? ["include=" + include] : [];
}
function prepareFields(fields) {
    var list = [];
    Object.keys(fields).forEach(function (key) {
        list.push("fields[" + key + "]=" + fields[key]);
    });
    return list;
}
function prepareRawParams(params) {
    return params.map(function (param) {
        if (typeof param === 'string') {
            return param;
        }
        return param.key + "=" + param.value;
    });
}
function prefixUrl(url) {
    if (URL_REGEX.test(url)) {
        return url;
    }
    return "" + config.baseUrl + url;
}
function appendParams(url, params) {
    var newUrl = url;
    if (params.length) {
        var separator = newUrl.indexOf('?') === -1 ? '?' : '&';
        newUrl += separator + params.join('&');
    }
    return newUrl;
}
function parametrize(params, scope) {
    if (scope === void 0) { scope = ''; }
    var list = [];
    Object.keys(params).forEach(function (key) {
        if (params[key] instanceof Array) {
            if (config.paramArrayType === ParamArrayType.OBJECT_PATH) {
                list.push.apply(list, parametrize(params[key], key + "."));
            }
            else if (config.paramArrayType === ParamArrayType.COMMA_SEPARATED) {
                list.push({ key: "" + scope + key, value: params[key].join(',') });
            }
            else if (config.paramArrayType === ParamArrayType.MULTIPLE_PARAMS) {
                list.push.apply(list, params[key].map(function (param) { return ({ key: "" + scope + key, value: param }); }));
            }
            else if (config.paramArrayType === ParamArrayType.PARAM_ARRAY) {
                list.push.apply(list, params[key].map(function (param) { return ({ key: "" + scope + key + "][", value: param }); }));
            }
        }
        else if (typeof params[key] === 'object') {
            list.push.apply(list, parametrize(params[key], key + "."));
        }
        else {
            list.push({ key: "" + scope + key, value: params[key] });
        }
    });
    return list;
}
function encodeParam(param) {
    // Manually decode field-value separator (=)
    return encodeURIComponent(param).replace('%3D', '=');
}

function flattenModel(classRefs, data) {
    var _a, _b;
    if (!data) {
        return null;
    }
    var rawData = (_a = {},
        _a[META_FIELD] = (_b = {
                fields: Object.keys(data.attributes || {}),
                id: data.id
            },
            _b[MODEL_LINKS_FIELD] = data.links,
            _b[MODEL_META_FIELD] = data.meta,
            _b[MODEL_PERSISTED_FIELD] = Boolean(data.id),
            _b.refs = {},
            _b.type = data.type,
            _b),
        _a);
    if (data.relationships) {
        var refLinks_1 = {};
        var refMeta_1 = {};
        var refs_1 = {};
        Object.keys(data.relationships).forEach(function (key) {
            var _a;
            var ref = data.relationships[key];
            if (ref && 'data' in ref && ref.data) {
                if ((!(ref.data instanceof Array) || ref.data.length > 0)) {
                    rawData[key] = mapItems(ref.data, function (item) { return item.id; });
                    if (!classRefs || !(key in classRefs)) {
                        refs_1[key] = {
                            model: ref.data instanceof Array ? ref.data[0].type : ref.data.type,
                            type: ref.data instanceof Array ? ReferenceType.TO_MANY : ReferenceType.TO_ONE,
                        };
                    }
                }
                else {
                    rawData[key] = [];
                }
            }
            if (ref && 'links' in ref) {
                refLinks_1[key] = ref.links;
            }
            if (ref && 'meta' in ref) {
                refMeta_1[key] = ref.meta;
            }
            (_a = rawData[META_FIELD].fields).push.apply(_a, Object.keys(refs_1));
        });
        rawData[META_FIELD].refs = refs_1;
        rawData[META_FIELD][MODEL_REF_LINKS_FIELD] = refLinks_1;
        rawData[META_FIELD][MODEL_REF_META_FIELD] = refMeta_1;
    }
    return Object.assign(rawData, data.attributes);
}
function getModelMeta(model) {
    return getModelMetaKey(model, MODEL_META_FIELD);
}
function getModelLinks(model) {
    return getModelMetaKey(model, MODEL_LINKS_FIELD);
}
function fetchModelLink(model, key, requestHeaders, options) {
    return __awaiter(this, void 0, void 0, function () {
        var collection, links, link, responseObj;
        return __generator(this, function (_a) {
            collection = getModelCollection(model);
            links = getModelLinks(model);
            if (!links || !(key in links)) {
                throw error("Link " + key + " doesn't exist on the model");
            }
            link = links[key];
            responseObj = fetchLink(link, collection, requestHeaders, options);
            if (getModelMetaKey(model, MODEL_QUEUE_FIELD)) {
                return [2 /*return*/, responseObj.then(function (response) {
                        var related = getModelMetaKey(model, MODEL_RELATED_FIELD);
                        var prop = getModelMetaKey(model, MODEL_PROP_FIELD);
                        var record = response.data;
                        var recordType = record && getModelType(record);
                        if (record && recordType !== getModelType(model) && recordType === getModelType(related)) {
                            if (prop) {
                                related[prop] = record;
                                return response;
                            }
                            setModelMetaKey(related, MODEL_PERSISTED_FIELD, true);
                            return response.replaceData(related);
                        }
                        return response;
                    })];
            }
            return [2 /*return*/, responseObj];
        });
    });
}
function getLink(model, ref, key) {
    var collection = getModelCollection(model);
    if (!collection) {
        throw error('The model needs to be in a collection');
    }
    var links = getModelRefLinks(model);
    if (!links || !(ref in links)) {
        throw error("The reference " + ref + " doesn't have any links");
    }
    var refLinks = links[ref];
    if (!refLinks || !(key in refLinks)) {
        throw error("Link " + key + " doesn't exist on the model");
    }
    return refLinks[key];
}
function fetchModelRefLink(model, ref, key, requestHeaders, options) {
    return __awaiter(this, void 0, void 0, function () {
        var collection, link;
        return __generator(this, function (_a) {
            collection = getModelCollection(model);
            link = getLink(model, ref, key);
            return [2 /*return*/, fetchLink(link, collection, requestHeaders, options)];
        });
    });
}
function getModelRefLinks(model) {
    return getModelMetaKey(model, MODEL_REF_LINKS_FIELD);
}
function getModelRefMeta(model) {
    return getModelMetaKey(model, MODEL_REF_META_FIELD);
}
function isModelPersisted(model) {
    return getModelMetaKey(model, MODEL_PERSISTED_FIELD);
}
function setModelPersisted(model, status) {
    setModelMetaKey(model, MODEL_PERSISTED_FIELD, status);
}
function modelToJsonApi(model) {
    var staticModel = model.constructor;
    var attributes = modelToJSON(model);
    var useAutogenerated = staticModel['useAutogeneratedIds'];
    var isPersisted = isModelPersisted(model);
    var data = {
        attributes: attributes,
        id: (isPersisted || useAutogenerated) ? getModelId(model) : undefined,
        type: getModelType(model),
    };
    var refs = getModelMetaKey(model, 'refs');
    Object.keys(refs).forEach(function (key) {
        data.relationships = data.relationships || {};
        var refIds = getRefId(model, key);
        var rel;
        if (refIds instanceof Array || isObservableArray(refIds)) {
            rel = refIds.map(function (id, index) {
                var type = getModelType(model[key][index] ? model[key][index] : refs[key].model).toString();
                if (!type) {
                    throw error("The model type can't be retrieved for the reference " + key);
                }
                return { id: id, type: type };
            });
        }
        else {
            var type = getModelType(model[key] ? model[key] : refs[key].model).toString();
            if (!type) {
                throw error("The model type can't be retrieved for the reference " + key);
            }
            rel = refIds ? { id: refIds, type: type } : undefined;
        }
        data.relationships[key] = { data: rel || null };
        if (data.attributes) {
            // tslint:disable-next-line:no-dynamic-delete
            delete data.attributes[key];
        }
    });
    if (data.attributes) {
        delete data.attributes.id;
        // tslint:disable-next-line:no-dynamic-delete
        delete data.attributes[META_FIELD];
    }
    return data;
}
function getModelEndpointUrl(model, options) {
    var queryData = prepareQuery(getModelType(model), isModelPersisted(model) ? getModelId(model) : undefined, undefined, options, undefined, model);
    return queryData.url;
}
function saveModel(model, options) {
    var collection = getModelCollection(model);
    var data = modelToJsonApi(model);
    var requestMethod = isModelPersisted(model) ? update : create;
    var url = getModelEndpointUrl(model, options);
    return requestMethod(url, { data: data }, collection, options && options.headers)
        .then(handleResponse(model))
        .then(function (response) {
        clearCacheByType(getModelType(model));
        return response;
    });
}
function removeModel(model, options) {
    var collection = getModelCollection(model);
    var isPersisted = isModelPersisted(model);
    var url = getModelEndpointUrl(model);
    if (isPersisted) {
        return remove(url, collection, options && options.headers)
            .then(function (response) {
            if (response.error) {
                throw response.error;
            }
            setModelPersisted(model, false);
            if (collection) {
                collection.removeOne(model);
            }
        });
    }
    else if (collection) {
        collection.removeOne(model);
    }
    return Promise.resolve();
}
function saveRelationship(model, ref, options) {
    var collection = getModelCollection(model);
    var link = getLink(model, ref, 'self');
    var href = typeof link === 'object' ? link.href : link;
    var ids = getRefId(model, ref);
    var type = getModelType(getModelMetaKey(model, 'refs')[ref].model);
    var data = mapItems(ids, function (id) { return ({ id: id, type: type }); });
    return update(href, { data: data }, collection, options && options.headers)
        .then(handleResponse(model, ref));
}

function decorateModel(BaseClass) {
    var JsonapiModel = /** @class */ (function (_super) {
        __extends(JsonapiModel, _super);
        function JsonapiModel(rawData, collection) {
            if (rawData === void 0) { rawData = {}; }
            var _this = this;
            var data = rawData;
            if ((rawData && 'type' in rawData) && ('attributes' in rawData || 'relationships' in rawData)) {
                var classRefs = getModelClassRefs(BaseClass);
                data = flattenModel(classRefs, rawData);
            }
            _this = _super.call(this, data, collection) || this;
            return _this;
        }
        JsonapiModel.prototype.save = function (options) {
            return saveModel(this, options);
        };
        JsonapiModel.prototype.destroy = function (options) {
            return removeModel(this, options);
        };
        /**
         * Should the autogenerated ID be sent to the server when creating a record
         *
         * @static
         * @type {boolean}
         * @memberOf Record
         */
        JsonapiModel.useAutogeneratedIds = BaseClass['useAutogeneratedIds'] || false;
        return JsonapiModel;
    }(BaseClass));
    return JsonapiModel;
}

var DecoratedModel = decorateModel(PureModel);
var GenericModel = /** @class */ (function (_super) {
    __extends(GenericModel, _super);
    function GenericModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return GenericModel;
}(DecoratedModel));

function decorateCollection(BaseClass) {
    var JsonapiCollection = /** @class */ (function (_super) {
        __extends(JsonapiCollection, _super);
        function JsonapiCollection() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        JsonapiCollection.prototype.sync = function (body) {
            var _this = this;
            if (!body) {
                return null;
            }
            var data = this.__iterateEntries(body, function (obj) { return _this.__addRecord(obj); });
            this.__iterateEntries(body, this.__updateRelationships.bind(this));
            return data;
        };
        /**
         * Fetch the records with the given type and id
         *
         * @param {string} type Record type
         * @param {number|string} type Record id
         * @param {IRequestOptions} [options] Server options
         * @returns {Promise<Response>} Resolves with the Response object or rejects with an error
         */
        JsonapiCollection.prototype.fetch = function (type, id, options) {
            var _this = this;
            var modelType = getModelType(type);
            var query = this.__prepareQuery(modelType, id, undefined, options);
            return read(query.url, this, query.headers, options)
                .then(function (res) { return _this.__handleErrors(res); });
        };
        /**
         * Fetch the first page of records of the given type
         *
         * @param {string} type Record type
         * @param {IRequestOptions} [options] Server options
         * @returns {Promise<Response>} Resolves with the Response object or rejects with an error
         */
        JsonapiCollection.prototype.fetchAll = function (type, options) {
            var _this = this;
            var modelType = getModelType(type);
            var query = this.__prepareQuery(modelType, undefined, undefined, options);
            return read(query.url, this, query.headers, options)
                .then(function (res) { return _this.__handleErrors(res); });
        };
        JsonapiCollection.prototype.request = function (url, method, data, options) {
            if (method === void 0) { method = 'GET'; }
            var query = buildUrl(url, data, options);
            return libFetch({ url: query.url, options: options, data: data, method: method, collection: this });
        };
        JsonapiCollection.prototype.removeOne = function (obj, id, remote) {
            var remove = (typeof id === 'boolean' || typeof id === 'object') ? id : remote;
            var modelId;
            if (typeof id === 'string' || typeof id === 'number') {
                modelId = id;
            }
            else if (typeof id === 'boolean' || obj instanceof PureModel) {
                modelId = getModelId(obj);
            }
            var type = getModelType(obj);
            var model = modelId !== undefined && this.findOne(type, modelId);
            if (model && modelId !== undefined && getModelId(model) !== modelId) {
                // The model is not in the collection and we shouldn't remove a random one
                return Promise.resolve();
            }
            if (model && remove) {
                return removeModel(model, typeof remove === 'object' ? remove : undefined);
            }
            if (model) {
                _super.prototype.removeOne.call(this, model);
            }
            clearCacheByType(type);
            return Promise.resolve();
        };
        JsonapiCollection.prototype.remove = function (obj, id, remote) {
            var remove = (typeof id === 'boolean' || typeof id === 'object') ? id : remote;
            var modelId;
            if (typeof id === 'string' || typeof id === 'number') {
                modelId = id;
            }
            else if (typeof id === 'boolean' || obj instanceof PureModel) {
                modelId = getModelId(obj);
            }
            var type = getModelType(obj);
            var model = this.find(type, modelId);
            if (model && modelId !== undefined && getModelId(model) !== modelId) {
                // The model is not in the collection and we shouldn't remove a random one
                return Promise.resolve();
            }
            if (model && remove) {
                return removeModel(model, typeof remove === 'object' ? remove : undefined);
            }
            if (model) {
                _super.prototype.removeOne.call(this, model);
            }
            clearCacheByType(type);
            return Promise.resolve();
        };
        JsonapiCollection.prototype.removeAll = function (type) {
            _super.prototype.removeAll.call(this, type);
            clearCacheByType(getModelType(type));
        };
        JsonapiCollection.prototype.reset = function () {
            _super.prototype.reset.call(this);
            clearAllCache();
        };
        /**
         * Function used to handle response errors
         *
         * @private
         * @param {Response} response API response
         * @returns API response
         */
        JsonapiCollection.prototype.__handleErrors = function (response) {
            if (response.error) {
                throw response.error;
            }
            return response;
        };
        JsonapiCollection.prototype.__addRecord = function (obj) {
            var staticCollection = this.constructor;
            var type = obj.type, id = obj.id;
            var record = id === undefined ? null : this.findOne(type, id);
            var Type = staticCollection.types.find(function (item) { return getModelType(item) === type; }) || GenericModel;
            var classRefs = getModelClassRefs(Type);
            var flattened = flattenModel(classRefs, obj);
            if (record) {
                updateModel(record, flattened);
            }
            else if (staticCollection.types.filter(function (item) { return item.type === type; }).length) {
                record = this.add(flattened, type);
            }
            else {
                record = this.add(new GenericModel(flattened));
            }
            return record;
        };
        JsonapiCollection.prototype.__updateRelationships = function (obj) {
            var _this = this;
            var record = obj.id === undefined ? null : this.findOne(obj.type, obj.id);
            var refs = obj.relationships ? Object.keys(obj.relationships) : [];
            refs.forEach(function (ref) {
                var refData = obj.relationships[ref];
                if (!refData || !('data' in refData)) {
                    return;
                }
                var items = refData.data;
                if (items instanceof Array && items.length < 1) {
                    // it's only possible to update items with one ore more refs. Early exit
                    return;
                }
                else if (record) {
                    if (items) {
                        var models = mapItems(items, function (def) { return (def.id === undefined ? null : _this.findOne(def.type, def.id)) || def.id; }) || null;
                        var itemType = items instanceof Array ? items[0].type : items.type;
                        if (ref in record) {
                            record[ref] = models;
                        }
                        else {
                            initModelRef(record, ref, { model: itemType, type: ReferenceType.TO_ONE_OR_MANY }, models);
                        }
                    }
                    else {
                        var refsDef = getModelMetaKey(record, 'refs');
                        if (refsDef && ref in refsDef) {
                            record[ref] = refsDef[ref].type === ReferenceType.TO_MANY ? [] : null;
                        }
                    }
                }
            });
        };
        JsonapiCollection.prototype.__iterateEntries = function (body, fn) {
            mapItems((body && body.included) || [], fn);
            return mapItems((body && body.data) || [], fn);
        };
        JsonapiCollection.prototype.__prepareQuery = function (type, id, data, options) {
            return prepareQuery(type, id, data, options, this);
        };
        JsonapiCollection.types = (BaseClass.types && BaseClass.types.length)
            ? BaseClass.types.concat(GenericModel)
            : [GenericModel];
        JsonapiCollection.cache = BaseClass['cache'] === undefined
            ? isBrowser
            : BaseClass['cache'];
        JsonapiCollection.defaultModel = BaseClass['defaultModel'] || GenericModel;
        __decorate([
            action
        ], JsonapiCollection.prototype, "sync", null);
        __decorate([
            action
        ], JsonapiCollection.prototype, "removeOne", null);
        __decorate([
            action
        ], JsonapiCollection.prototype, "remove", null);
        __decorate([
            action
        ], JsonapiCollection.prototype, "removeAll", null);
        __decorate([
            action
        ], JsonapiCollection.prototype, "reset", null);
        return JsonapiCollection;
    }(BaseClass));
    return JsonapiCollection;
}

function decorateView(BaseClass) {
    var JsonapiView = /** @class */ (function (_super) {
        __extends(JsonapiView, _super);
        function JsonapiView(modelType, collection, sortMethod, models, unique) {
            if (models === void 0) { models = []; }
            if (unique === void 0) { unique = false; }
            var _this = _super.call(this, modelType, collection, sortMethod, models, unique) || this;
            _this.__collection = collection;
            return _this;
        }
        JsonapiView.prototype.sync = function (body) {
            var data = this.__collection.sync(body);
            if (data) {
                this.add(data);
            }
            return data;
        };
        /**
         * Fetch the records with the given type and id
         *
         * @param {number|string} type Record id
         * @param {IRequestOptions} [options] Server options
         * @returns {Promise<Response>} Resolves with the Response object or rejects with an error
         */
        JsonapiView.prototype.fetch = function (id, options) {
            return this.__collection
                .fetch(this.modelType, id, options)
                .then(this.__addFromResponse.bind(this));
        };
        /**
         * Fetch the first page of records of the given type
         *
         * @param {IRequestOptions} [options] Server options
         * @returns {Promise<Response>} Resolves with the Response object or rejects with an error
         */
        JsonapiView.prototype.fetchAll = function (options) {
            return this.__collection
                .fetchAll(this.modelType, options)
                .then(this.__addFromResponse.bind(this));
        };
        JsonapiView.prototype.__addFromResponse = function (response) {
            if (response.data) {
                this.add(response.data);
            }
            response.views.push(this);
            return response;
        };
        return JsonapiView;
    }(BaseClass));
    // @ts-ignore
    return JsonapiView;
}

function jsonapi(Base) {
    if (isModel(Base)) {
        // @ts-ignore
        return decorateModel(Base);
    }
    else if (isCollection(Base)) {
        // @ts-ignore
        return decorateCollection(Base);
    }
    else if (isView(Base)) {
        // @ts-ignore
        return decorateView(Base);
    }
    throw new Error('The instance needs to be a model, collection or a view');
}

export { GenericModel, ParamArrayType, Response, buildUrl, clearAllCache, clearCacheByType, config, fetchModelLink, fetchModelRefLink, getModelEndpointUrl, getModelLinks, getModelMeta, getModelRefLinks, getModelRefMeta, jsonapi, modelToJsonApi, prepareQuery, saveModel, saveRelationship };
